import { EVENT_SOURCE } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

type OnLinkedJiraIssuesFetchSuccessArgs = {
	issueCount: number;
};

/**
 * Fires when the linked Jira issues hydration fetch from UGS Cypher query API succeeds.
 */
export const onLinkedJiraIssuesFetchSuccess = ({
	issueCount,
}: OnLinkedJiraIssuesFetchSuccessArgs): FireAnalyticsEvent => {
	return {
		action: 'taskSuccess',
		actionSubject: 'linkedJiraIssuesFetch',
		eventType: 'operational',
		source: EVENT_SOURCE,
		attributes: {
			additionalAttributes: {
				issueCount,
			},
		},
	};
};

type OnLinkedJiraIssuesFetchFailArgs = {
	reason: string;
};

/**
 * Fires when the linked Jira issues hydration fetch from UGS Cypher query API fails.
 */
export const onLinkedJiraIssuesFetchFail = ({
	reason,
}: OnLinkedJiraIssuesFetchFailArgs): FireAnalyticsEvent => {
	return {
		action: 'taskFail',
		actionSubject: 'linkedJiraIssuesFetch',
		eventType: 'operational',
		source: EVENT_SOURCE,
		attributes: {
			additionalAttributes: {
				reason,
			},
		},
	};
};
